module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av618-4bc6cb4be1b2bc749eb9d18dbbc1c963.jpg";